import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import config from './config.json';

window.services = {};

const isAcceptance = process.env.REACT_APP_GUILD_BASE_URL?.includes('guildacceptance.com');

// webpack only inline-replaces statically-written process.env.X references (a dynamic process.env[key] resolves to an empty object at runtime)
// Only set in .env.local for local dev (localhost or a PR preview); staging/prod fall back to defaultUrl.
const ENV_OVERRIDES: Record<string, string | undefined> = {
  REACT_APP_MFE_SERVICE_NAV_URL: process.env.REACT_APP_MFE_SERVICE_NAV_URL,
  REACT_APP_MFE_CATALOG_TOOLS_URL: process.env.REACT_APP_MFE_CATALOG_TOOLS_URL,
  REACT_APP_MFE_COMMS_MEMBER_PREFERENCES_URL:
    process.env.REACT_APP_MFE_COMMS_MEMBER_PREFERENCES_URL,
  REACT_APP_MFE_ELIGIBILITY_WIDGET_URL: process.env.REACT_APP_MFE_ELIGIBILITY_WIDGET_URL,
  REACT_APP_MFE_FEEDBACK_WIDGET_URL: process.env.REACT_APP_MFE_FEEDBACK_WIDGET_URL,
  REACT_APP_MFE_MEMBER_CHAT_URL: process.env.REACT_APP_MFE_MEMBER_CHAT_URL,
  REACT_APP_MFE_EMBEDDED_MESSAGING_URL: process.env.REACT_APP_MFE_EMBEDDED_MESSAGING_URL,
};

config.services.forEach(({ subdomain }) => {
  const envSubdomain = isAcceptance ? `${subdomain}-staging` : subdomain;
  const NAME = snakeCase(subdomain).toUpperCase().replace(/\./, '_');
  const envKey = `REACT_APP_${NAME}_URL`;
  const defaultUrl = `https://${envSubdomain}.${process.env.REACT_APP_GUILD_BASE_URL}`;

  window.services[camelCase(subdomain)] = ENV_OVERRIDES[envKey] || defaultUrl;
});

import(/* webpackChunkName: "host" */ './index');
